import React from "react";
import { Card } from "react-bootstrap";
import { BiMessageAltX } from "react-icons/bi";
import { PiWarningBold } from "react-icons/pi";
import { MdOutlineEventRepeat } from "react-icons/md";
import { RxExit } from "react-icons/rx";

const AlertItem = ({ alert, index, totalItems }) => {
  // Function to get the border color based on alert type
  const getBorderColor = () => {
    const alertType = alert.alert_type.charAt(0).toUpperCase() + alert.alert_type.slice(1).toLowerCase();
    switch (alertType) {
      case "Error":
        return "#f5c6cb"; // Red border for errors
      case "Warning":
        return "#ffeeba"; // Yellow border for warnings
      case "Event":
        return "#bee5eb"; // Blue border for events
      default:
        return "#c8cbcf"; // Gray border for default
    }
  };

  // Function to get the associated data (project, workstream, organization, paper)
  const getAssociatedData = () => {
    if (alert.context?.type === "project") {
      return `${alert.context.name}`;
    } else if (alert.context?.type === "workstream") {
      return `${alert.context.name}`;
    } else if (alert.context?.type === "organization") {
      return `${alert.context.name}`;
    } else if (alert.context?.type === "paper") {
      return `${alert.context.name}`;
    }
  };

  // Function to render icon based on alert type
  const renderAlertIcon = () => {
    const alertType = alert.alert_type.charAt(0).toUpperCase() + alert.alert_type.slice(1).toLowerCase();
    switch (alertType) {
      case "Error":
        return <BiMessageAltX size={24} color="rgb(230, 126, 62)"/>; // Red icon for errors
      case "Warning":
        return <PiWarningBold size={24} color="#ffc107" />; // Yellow icon for warnings
      case "Event":
        return <MdOutlineEventRepeat size={24} color="#17a2b8" />; // Blue icon for events
      default:
        return <MdOutlineEventRepeat size={24} color="#6c757d" />; // Default gray icon
    }
  };

  // Apply border radius only to the first, last, and single items
  const getBorderRadius = () => {
    if (totalItems === 1) {
      return "0 0 10px 10px ";
    } else if (index === totalItems - 1) {
      return "0 0 10px 10px";
    } else {
      return "0";
    }
  };

  return (
    <div className="px-2">
      <Card className="p-0" style={{ border: 0 }}>
        <Card.Body
          style={{
            backgroundColor: "transparent", // Keep background transparent
            borderRadius: getBorderRadius(),
            border: `2px solid ${getBorderColor()}`, // Border color based on alert type
          }}
          className="pt-4 px-2 py-3 align-items-center"
        >
          <div className="row">
            <div className="col-12 col-sm-2 fs-5 d-flex align-items-center gap-2">
              {/* Render icon based on alert type */}
              <p>{renderAlertIcon()}</p>
              <p>{getAssociatedData()}</p>
            </div>
            <div className="col-12 col-sm-7 fs-5">
              <p>{alert.message}</p>
            </div>
            <div className="col-12 col-sm-2 fs-5">
              <p>{new Date(alert.timestamp).toLocaleString()}</p>
            </div>
            <div className="col-12 col-sm-1 fs-5 text-end">
              {/* Exit button inside a light gray circle */}
              <button 
                className="btn p-2 rounded-circle" 
                style={{
                  backgroundColor: "#f8f9fa", // Light gray background
                  border: "1px solid #ccc",    // Light gray border
                  padding: "12px",              // Adjust padding for a rounded button
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                title="Exit"
              >
                <RxExit size={18}  />
              </button>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AlertItem;
